<template>
  <div class="asc-mx-status-icon">
    <div class="asc-mx-status-icon--single">
      <asc-icon icon="square" :color="getBgColor" :size="14"></asc-icon>
    </div>
  </div>
</template>

<script>
import AscIcon from './AscIcon'

import { MX_STATUSES } from '@/utilities/appConsts'

export default {
  name: 'AscMxStatusIcon',

  components: {
    AscIcon,
  },

  props: {
    statusName: {
      type: String,
      required: true,
    },
  },

  computed: {
    getBgColor() {
      const foundStatus = MX_STATUSES.find(
        status => status.name === this.statusName,
      )

      if (foundStatus) {
        return foundStatus.color
      }

      return ''
    },
  },
}
</script>
